(function () {
  var DESKTOP_MQ = '(min-width: 921px)';
  var ROOT_SELECTOR = '[data-product-metaobject-root]';
  var HOME_SELECTOR = '[data-product-metaobject-home]';
  var SLOT_SELECTOR = '[data-product-metaobject-slot="gallery"]';

  function place() {
    var isDesktop = window.matchMedia(DESKTOP_MQ).matches;
    var roots = document.querySelectorAll(ROOT_SELECTOR);

    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var homeId = root.getAttribute('data-product-metaobject-home-id');
      var home = (homeId && document.querySelector(HOME_SELECTOR + '[data-product-metaobject-home="' + homeId + '"]'))
        || root.closest(HOME_SELECTOR);
      var scope = (home && home.closest('.product')) || root.closest('.product') || document;
      var slot = scope.querySelector(SLOT_SELECTOR);

      if (isDesktop && slot) {
        if (root.parentNode !== slot) slot.appendChild(root);
      } else if (home) {
        if (root.parentNode !== home) home.appendChild(root);
      }
    }
  }

  function bind() {
    if (window.__productMetaobjectPlacementBound) return;
    window.__productMetaobjectPlacementBound = true;

    var media = window.matchMedia(DESKTOP_MQ);
    if (media.addEventListener) {
      media.addEventListener('change', place);
    } else if (media.addListener) {
      media.addListener(place);
    }

    document.addEventListener('shopify:section:load', place);
    document.addEventListener('shopify:section:reorder', place);
    document.addEventListener('shopify:block:select', place);
    document.addEventListener('shopify:block:deselect', place);
  }

  bind();
  place();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  }
})();
